import React from 'react';
import {
  CognitoUserPool,
  CognitoUser,
  CognitoRefreshToken,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoUserSession,
} from 'amazon-cognito-identity-js';
import { authConfig } from '../../configures/awsConfig.js';
import QueryStrUtil from '../util/queryStrUtil.js';

const myQueryStrUtil = new QueryStrUtil();

/**
 * ラプラスパスポートからリダイレクトされた際に、クエリパラメータの refresh_token を使って
 * Cognito セッションを構築し、サインイン済み状態にするコンポーネント。
 *
 * 想定 URL: https://laplaceid.energymntr.com/?action=session_share&refresh_token=xxx&callback=https://laplacepassport.energymntr.com/
 */
export default class SessionShare extends React.Component {
  componentDidMount() {
    const refreshToken = myQueryStrUtil.getParamContent('refresh_token');
    const callback = myQueryStrUtil.getParamContent('callback');

    if (!refreshToken) {
      window.location.href = '/';
      return;
    }

    this.restoreSession(refreshToken, callback);
  }

  async restoreSession(tokenStr, callback) {
    try {
      // Cognito InitiateAuth API を直接呼び、refreshToken から新しいトークンセットを取得
      const region = authConfig.userPoolId.split('_')[0];
      const res = await fetch(
        `https://cognito-idp.${region}.amazonaws.com/`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-amz-json-1.1', 'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth' },
          body: JSON.stringify({
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            ClientId: authConfig.userPoolWebClientId,
            AuthParameters: { REFRESH_TOKEN: tokenStr },
          }),
        }
      );

      if (!res.ok) throw new Error('InitiateAuth failed');

      const data = await res.json();
      const { IdToken, AccessToken } = data.AuthenticationResult;

      // idToken のペイロードから username を取得（Base64URL をデコード）
      const base64Url = IdToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(base64));
      const username = payload['cognito:username'];

      // amazon-cognito-identity-js を使って localStorage にセッションを保存
      const userPool = new CognitoUserPool({
        UserPoolId: authConfig.userPoolId,
        ClientId: authConfig.userPoolWebClientId,
      });

      const cognitoUser = new CognitoUser({ Username: username, Pool: userPool });

      const session = new CognitoUserSession({
        IdToken: new CognitoIdToken({ IdToken }),
        AccessToken: new CognitoAccessToken({ AccessToken }),
        RefreshToken: new CognitoRefreshToken({ RefreshToken: tokenStr }),
      });

      // 既存セッションをクリアしてから新しいセッションを保存する
      const prefix = `CognitoIdentityServiceProvider.${authConfig.userPoolWebClientId}.`;
      Object.keys(localStorage)
        .filter(key => key.startsWith(prefix))
        .forEach(key => localStorage.removeItem(key));

      cognitoUser.setSignInUserSession(session);

      // URL からトークンを除去（ブラウザ履歴・リファラへの露出防止）してからリダイレクト
      window.history.replaceState({}, document.title, '/');

      if (callback && this.isAllowedCallback(callback)) {
        window.location.href = callback;
      } else {
        window.location.href = '/';
      }
    } catch (err) {
      console.error('SessionShare: restoreSession failed', err);
      window.location.href = '/';
    }
  }

  isAllowedCallback(url) {
    try {
      const allowed = new URL(process.env.REACT_APP_LAPLACE_PASSPORT_APP_URL);
      const target = new URL(url);
      return target.origin === allowed.origin;
    } catch (_) {
      return false;
    }
  }

  render() {
    return <div />;
  }
}
